import { t } from '@lingui/core/macro';
import { NoddiButton, NoddiOtp } from 'noddi-ui-web';

export const VERIFICATION_CODE_LENGTH = 6;

type Props = {
  kind: 'email' | 'phoneNumber';
  /** Where the code went — shown so a typo in the new value is caught before the code is entered. */
  destination: string;
  code: string;
  isResending: boolean;
  onCodeChange: (code: string) => void;
  onResend: () => void;
};

/**
 * Sits directly under the field the user changed. Nobody who leaves their contact details alone
 * ever sees this — confirming unchanged details stays a single click.
 */
export const ContactVerificationCode = ({ kind, destination, code, isResending, onCodeChange, onResend }: Props) => (
  <div className='flex flex-col items-start gap-2 rounded-lg bg-muted p-3'>
    <p className='text-sm'>
      {kind === 'email' ? t`Code sent to ${destination}` : t`Code sent by SMS to ${destination}`}
    </p>
    <NoddiOtp
      value={code}
      onChange={onCodeChange}
      maxLength={VERIFICATION_CODE_LENGTH}
      autoFocus={false}
      aria-label={t`Verification code`}
    />
    <NoddiButton variant='link' size='small' loading={isResending} disabled={isResending} onClick={onResend}>
      {t`Send a new code`}
    </NoddiButton>
  </div>
);
